/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CostInputs */

const en_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost`)
};

const fr_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coût`)
};

const de_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten`)
};

const it_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo`)
};

const ru_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расходы`)
};

const es_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo`)
};

const zh_cn2_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成本`)
};

const ja_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`料金`)
};

const hi_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लागत`)
};

const pt_pt2_cost = /** @type {(inputs: CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custo`)
};

/**
* | output |
* | --- |
* | "Cost" |
*
* @param {CostInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cost = /** @type {((inputs?: CostInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CostInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cost(inputs)
	if (locale === "de") return de_cost(inputs)
	if (locale === "it") return it_cost(inputs)
	if (locale === "ru") return ru_cost(inputs)
	if (locale === "es") return es_cost(inputs)
	if (locale === "zh-CN") return zh_cn2_cost(inputs)
	if (locale === "ja") return ja_cost(inputs)
	if (locale === "hi") return hi_cost(inputs)
	if (locale === "pt-PT") return pt_pt2_cost(inputs)
	return en_cost(inputs)
});